<template>
  <b-container class="p-0">
    <b-row class="m-0">
      <b-col class="p-0">
        <div class="profile-picture-container">
          <b-row>
            <b-col>
              <div
                :style="{
                  backgroundImage: `url('${userInfo.profile_picture}')`,
                }"
                class="profile-picture"
              >
                <b-button
                  v-if="
                    userInfo.follow_status &&
                    !!userInfo.follow_status.following === false
                  "
                  class="other-profile-follow-btn"
                  squared
                  variant="info"
                  @click="followReq"
                >
                  <i class="far fa-eye"></i> Follow
                </b-button>
                <b-button
                  class="other-profile-follow-btn"
                  squared
                  variant="info"
                  v-if="
                    userInfo.follow_status &&
                    !!userInfo.follow_status.following === true
                  "
                  v-on:click="UnFollowReq"
                >
                  <i class="far fa-eye-slash"></i> Unfollow
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center">
              <router-link
                :to="{
                  name: 'userProfilePage',
                  params: { customerId: $route.params.customerId },
                }"
              >
                <b-button class="go-to-profile-btn" block squared
                  >PROFILE</b-button
                >
              </router-link>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col class="text-center">
              <h2 class="bigName">
                {{ userInfo.user.first_name }} {{ userInfo.user.last_name }}
              </h2>
              <p class="big-work-info">{{ userInfo.job_title }}</p>
              <router-link
                :to="{
                  name: 'companyProfile',
                  params: { companyId: getId(userInfo.company) },
                }"
              >
                <p class="big-profile-text">{{ userInfo.company_name }}</p>
              </router-link>
            </b-col>
          </b-row>
          <hr class="user-profile-hr" />
          <b-row class="mb-3 mt-3">
            <b-col>
              <div class="profile-segments-div">
                <b-badge
                  v-for="segment in userInfo.tags"
                  :key="segment.id"
                  class="profile-segment"
                  variant="dark"
                  >{{ segment.name }}</b-badge
                >
              </div>
            </b-col>
          </b-row>
          <b-row class="no-gutters mt-3">
            <b-col>
              <b-button
                class="profile-message-btn p-0"
                block
                squared
                @click="sendMsg"
              >
                <i class="far fa-envelope profile-message-icon"></i>
                Message
              </b-button>
            </b-col>
            <b-col>
              <b-button
                class="profile-follow-btn"
                block
                squared
                v-if="
                  userInfo.friendship_status &&
                  userInfo.friendship_status.status === ''
                "
                @click="toNetwork()"
              >
                <i class="fas fa-user-plus profile-follow-icon"></i>
                Add to Network
              </b-button>
              <b-button
                class="profile-follow-btn"
                v-if="
                  userInfo.friendship_status &&
                  userInfo.friendship_status.status === 'sent request'
                "
                block
                squared
              >
                <i class="fas fa-users profile-follow-icon"></i>
                Request sent
              </b-button>
              <b-button
                class="profile-follow-btn"
                v-if="
                  userInfo.friendship_status &&
                  userInfo.friendship_status.status === 'pending request or you'
                "
                block
                squared
              >
                <i class="fas fa-users profile-follow-icon"></i>
                Sent you request
              </b-button>
              <b-button
                class="profile-follow-btn Unfriend"
                v-if="
                  userInfo.friendship_status &&
                  userInfo.friendship_status.status === 'friend'
                "
                block
                squared
                @click="unfriendReq"
              >
                <i class="fas fa-user-times profile-follow-icon"></i>
                Unfriend
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-modal
      v-model="congratulationModalShow"
      size="md"
      hide-footer
      @click="
        congratulationModalShow = false;
        networkModalText = '';
      "
    >
      <h3 style="text-align: center">CONGRATULATIONS!</h3>
      <p style="text-align: center">{{ networkModalText }}</p>
      <div class="congratulationModal">
        <router-link :to="{ name: 'network' }">My Network</router-link>
        <button
          @click="
            congratulationModalShow = false;
            networkModalText = '';
          "
        >
          Continue
        </button>
      </div>
    </b-modal>
    <notifications group="profile" position="bottom left" />
  </b-container>
</template>

<script>
import OtherProfile from '../../utils/mixins/OtherProfile';

export default {
  name: 'OtherProfilePage',
  mixins: [OtherProfile],

};
</script>
<style scoped>
.profile-picture-container {
  background: white;
}
.profile-picture {
  height: 280px;
  width: 100%;
  background-size: cover;
  background-position: center;
}
.profile-segments-div {
  padding: 0 15px 0 15px;
  text-align: left;
}
.profile-segments-div > span {
  border-radius: 0 8px 8px 8px;
}
.profile-segment {
  margin: 5px;
  padding: 4px 8px;
  background-color: #dbdbdb;
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: normal;
  font-family: Arial;
  text-align: left;
  color: #7f7f7f;
  font-weight: normal;
  border-radius: 0 10px 10px 10px;
}
.profile-message-btn {
  font-size: 14px;
  background-color: #bd9d5f;
  color: #fff;
  text-align: center;
  box-shadow: none;
  min-height: 30px;
  min-width: 30px;
  height: 100% !important;
}
.profile-message-btn:hover {
  color: #bd9d5f;
  background-color: #fff;
}
.profile-follow-btn {
  background-color: #bd9d5f;
  color: white;
  font-size: 14px;
  text-align: center;
  border: 0;
  border-left: 1px solid white;
  box-shadow: none;
  min-height: 30px;
  min-width: 30px;
}
.profile-follow-btn:hover {
  color: #bd9d5f;
  background-color: #fff;
}
.profile-message-icon,
.profile-follow-icon {
  font-size: 13.5px;
}
.go-to-profile-btn {
  background-color: #bd9d5f;
  box-shadow: none;
  border: 0;
  font-family: Arial;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  margin-top: 1px;
}
.go-to-profile-btn:active,
.other-profile-follow-btn,
.profile-message-btn,
.profile-follow-btn {
  box-shadow: none !important;
  background-color: #bd9d5f;
  border: 1px solid #bd9d5f;
  color: #fff;
}
.other-profile-follow-btn {
  margin: 5px 0 0 5px;
  border-radius: 0 10px 10px 10px !important;
  font-size: 13px;
  padding: 2px 7px;
}
.other-profile-follow-btn:hover {
  color: #bd9d5f;
  background-color: #fff;
  border-color: #fff;
}
.bigName {
  color: #333333;
  font-size: 22px;
  font-weight: bold;
  padding-top: 17px;
  text-transform: capitalize;
  margin: 0;
}
.big-work-info {
  color: gray;
}
.big-profile-text,
.big-work-info {
  font-size: 14px;
  margin-bottom: 0rem;
  padding-bottom: 15px;
  text-transform: capitalize;
  padding: 0;
}
.big-profile-text {
  color: #bd9d5f;
}
.user-profile-hr {
  background: whitesmoke;
  margin: 0rem;
}
.Unfriend {
  background-color: #aaa !important;
}
.congratulationModal {
  display: flex;
  justify-content: center;
  align-items: center;
}
.congratulationModal a,
.congratulationModal button {
  color: #bd9d5f;
  background-color: #fff;
  border: 1px solid #bd9d5f;
  padding: 3px 10px;
  margin-right: 10px;
}
.congratulationModal a:hover,
.congratulationModal button:hover {
  color: #fff;
  background-color: #bd9d5f;
  border: 1px solid #fff;
}
</style>
